import { render, staticRenderFns } from "./Reservation.vue?vue&type=template&id=6e81a5c8&scoped=true"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"
import style0 from "./Reservation.vue?vue&type=style&index=0&id=6e81a5c8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81a5c8",
  null
  
)

export default component.exports